import { Col, Modal, Row } from 'antd'
import { EmptyDiv } from 'components/UIComponents/CommonStyledDiv/index.js'
import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { ShipText } from '../../../modules/JobRoles/PageHeader/style'
import CloseIcon from '../../icons/CloseIcon'
const Modals = styled(Modal)`
  .ant-modal-content {
    border-radius: 10px;
    width: 50em;
  }
  .ant-modal-body {
    padding: 0;
  }
  .model-content {
    padding: 20px;
  }
`
export default function FilterChipComponent({
  data,
  handleClick,
  open,
  handleRemoveFilter,
}) {
  const modalRef = useRef()
  useEffect(() => {
    const handleClickOutside = event => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleClick()
      }
    }
    if (open) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [open, handleClick])

  return (
    <>
      <Row gutter={8}>
        {data.slice(0, 5).map((item, index) => {
          return (
            <Col key={index + item?.label}>
              <ShipText>
                <div style={{ textTransform: 'capitalize' }}>{item.label}</div>
                <EmptyDiv
                  onClick={() => handleRemoveFilter(item)}
                  style={{ marginTop: 3 }}
                >
                  <CloseIcon width={15} height={15} />
                </EmptyDiv>
              </ShipText>
            </Col>
          )
        })}
        {data.length > 5 && (
          <Col>
            <ShipText onClick={handleClick} style={{ cursor: 'pointer' }}>
              <div>...</div>
            </ShipText>
          </Col>
        )}
      </Row>
      <div>
        <Modals
          title=""
          closable={false}
          style={{ width: '500px' }}
          open={open}
          footer={false}
        >
          <div ref={modalRef} className="model-content">
            <div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              ></div>
              <div>
                <Row gutter={8}>
                  {data.map((item, index) => {
                    return (
                      <Col key={index + 'key'} style={{ marginBottom: '10px' }}>
                        <ShipText>
                          <div>{item.label}</div>
                          <EmptyDiv
                            onClick={() => handleRemoveFilter(item)}
                            style={{ marginTop: 3 }}
                          >
                            <CloseIcon width={15} height={15} />
                          </EmptyDiv>
                        </ShipText>
                      </Col>
                    )
                  })}
                </Row>
              </div>
            </div>
          </div>
        </Modals>
      </div>
    </>
  )
}
